// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* ReasonForContactInput.module.scss */
.ReasonForContactInput_container__uG8fr {
  display: flex;
  text-align: center;
  flex-direction: column;
  margin-bottom: 5px;
  padding: 8px;
  background-color: #ffffff;
  border-radius: 4px;
}

.ReasonForContactInput_label__LA4Or {
  font-size: 0.9em;
  font-weight: bold;
  color: var(--accent-color);
  margin-bottom: 10px;
  font-family: "Arial", sans-serif;
}

.ReasonForContactInput_textarea__VfUVh {
  padding: 8px;
  border-radius: 4px;
  font-size: 16px;
  font-family: "Arial", sans-serif;
  color: var(--accent-color);
  background-color: white;
  outline: none;
  resize: none;
}
.ReasonForContactInput_textarea__VfUVh:focus {
  border-color: #007bff;
  box-shadow: 0 0 8px rgba(0, 123, 255, 0.2);
}
@media (max-width: 768px) {
  .ReasonForContactInput_textarea__VfUVh {
    font-size: 14px;
  }
}

/* Add a custom style for the placeholder text */
.ReasonForContactInput_textarea__VfUVh::placeholder {
  color: var(--accent-color-xxx-dark-04-opacity); /* Default placeholder color */
}
.ReasonForContactInput_textarea__VfUVh::placeholder:hover, .ReasonForContactInput_textarea__VfUVh::placeholder:focus, .ReasonForContactInput_textarea__VfUVh::placeholder:active {
  color: var(--accent-color-xxx-dark-09-opacity); /* Change color on hover, focus, and active */
}

.ReasonForContactInput_typewriter__4A4Ko {
  font-family: monospace;
  font-size: 0.8em;
  white-space: nowrap;
  overflow: hidden; /* Ensures the content is not revealed until the animation */
  border-right: 0.15em solid green; /* Creates the typing cursor */
  animation: ReasonForContactInput_typing__-riLS 3.5s steps(40, end), ReasonForContactInput_blink-caret__F92J4 0.75s step-end infinite;
}

/* The typing effect */
@keyframes ReasonForContactInput_typing__-riLS {
  from {
    width: 0;
  }
  to {
    width: 100%;
  }
}
/* The typewriter cursor effect */
@keyframes ReasonForContactInput_blink-caret__F92J4 {
  from, to {
    border-color: transparent;
  }
  50% {
    border-color: green;
  }
}`, "",{"version":3,"sources":["webpack://./src/Pages/Home/FrequncyKeepInTouch/ReasonForContactInput.module.scss"],"names":[],"mappings":"AAAA,sCAAA;AAWA;EACE,aAAA;EACA,kBAAA;EACA,sBAAA;EACA,kBAAA;EACA,YATa;EAUb,yBAbiB;EAcjB,kBAVc;AAChB;;AAaA;EACE,gBAAA;EACA,iBAAA;EACA,0BApBW;EAqBX,mBAAA;EACA,gCArBY;AAWd;;AAcA;EACE,YAzBa;EA0Bb,kBAzBc;EA0Bd,eAAA;EACA,gCA7BY;EA8BZ,0BA/BW;EAgCX,uBAAA;EACA,aAAA;EACA,YAAA;AAXF;AAaE;EACE,qBAvCY;EAwCZ,0CAAA;AAXJ;AAeE;EAhBF;IAiBI,eAAA;EAZF;AACF;;AAgBA,gDAAA;AACA;EACE,8CAAA,EAAA,8BAAA;AAbF;AAeE;EAGE,8CAAA,EAAA,6CAAA;AAfJ;;AAqBA;EACE,sBAAA;EACA,gBAAA;EACA,mBAAA;EACA,gBAAA,EAAA,4DAAA;EACA,gCAAA,EAAA,8BAAA;EACA,oIAAA;AAlBF;;AAqBA,sBAAA;AACA;EACE;IAAO,QAAA;EAjBP;EAkBA;IAAK,WAAA;EAfL;AACF;AAiBA,iCAAA;AACA;EACE;IAAW,yBAAA;EAdX;EAeA;IAAM,mBAAA;EAZN;AACF","sourcesContent":["/* ReasonForContactInput.module.scss */\n\n// Color and spacing variables\n$primary-color: #007bff; // Bright blue for primary actions\n$background-color: #ffffff; // Light background color\n$text-color: var(--accent-color); // Dark grey for text\n$font-family: 'Arial', sans-serif; // Modern, readable font\n$padding-base: 8px; // Base padding value\n$border-radius: 4px; // Border radius for roundness\n\n// Container styling\n.container {\n  display: flex;\n  text-align: center;\n  flex-direction: column;\n  margin-bottom: 5px;\n  padding: $padding-base;\n  background-color: $background-color;\n  border-radius: $border-radius;\n}\n\n// Label styling\n.label {\n  font-size: 0.9em;\n  font-weight: bold;\n  color: $text-color;\n  margin-bottom: 10px;\n  font-family: $font-family;\n}\n\n// Textarea styling\n.textarea {\n  padding: $padding-base;\n  border-radius: $border-radius;\n  font-size: 16px;\n  font-family: $font-family;\n  color: $text-color;\n  background-color: white;\n  outline: none;\n  resize: none; // Disable resizing of the textarea\n\n  &:focus {\n    border-color: $primary-color;\n    box-shadow: 0 0 8px rgba($primary-color, 0.2);\n  }\n\n  // Responsive behavior\n  @media (max-width: 768px) {\n    font-size: 14px;\n  }\n}\n\n\n/* Add a custom style for the placeholder text */\n.textarea::placeholder {\n  color: var(--accent-color-xxx-dark-04-opacity); /* Default placeholder color */\n\n  &:hover,\n  &:focus,\n  &:active {\n    color: var(--accent-color-xxx-dark-09-opacity); /* Change color on hover, focus, and active */\n  }\n}\n\n// Custom media query breakpoints can be added for further responsiveness\n\n.typewriter {\n  font-family: monospace;\n  font-size: 0.8em;\n  white-space: nowrap;\n  overflow: hidden; /* Ensures the content is not revealed until the animation */\n  border-right: .15em solid green; /* Creates the typing cursor */\n  animation: typing 3.5s steps(40, end), blink-caret .75s step-end infinite;\n}\n\n/* The typing effect */\n@keyframes typing {\n  from { width: 0 }\n  to { width: 100% }\n}\n\n/* The typewriter cursor effect */\n@keyframes blink-caret {\n  from, to { border-color: transparent }\n  50% { border-color: green }\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"container": `ReasonForContactInput_container__uG8fr`,
	"label": `ReasonForContactInput_label__LA4Or`,
	"textarea": `ReasonForContactInput_textarea__VfUVh`,
	"typewriter": `ReasonForContactInput_typewriter__4A4Ko`,
	"typing": `ReasonForContactInput_typing__-riLS`,
	"blink-caret": `ReasonForContactInput_blink-caret__F92J4`
};
export default ___CSS_LOADER_EXPORT___;
